export default __webpack_public_path__ + "static/media/TL07.1.ca0fff5c.mp3";